<div class="patron card mb-3 animation-fade-in" *ngIf="patron$ | async as patron">
  <div class="card-title">{{"PATRON.TITLE" | translate}}</div>

  <div class="card-body border border-1 border-gray-300 rounded overflow-hidden border-dashed d-flex flex-column p-3">
    <div class="d-flex flex-row mb-2">
      <div class="me-3 text-primary">
          <ng-container>
            <img alt="avatar" *ngIf="patron?.avatarUrl else avatarLoading"
              src="./assets/media/avatars/blank.png"
              [src]="patron?.avatarUrl"
              class="patron-avatar"
              height=50
              width=50
            />
            <ng-template #avatarLoading>
              <app-skeleton-loader class="w-50px h-50px"></app-skeleton-loader>
            </ng-template>
          </ng-container>
      </div>
      <div class="d-flex align-items-center">
          <div class="fw-bold text-gray-900" *ngIf="patron.firstName || patron.lastName">
            {{patron.firstName}} {{patron.lastName}}
          </div>
      </div>
    </div>
    <div class="d-flex flex-column flex-row-fluid">
        <div class="text-muted pb-1 d-flex align-items-start" *ngIf="patron.email">
          <i class="bi bi-envelope-fill flex-shrink-0 me-1 mt-1"></i>
          <span class="text-break">{{patron.email}}</span>
        </div>
        <div class="text-muted" *ngIf="patron.phone">
          <i class="bi bi-telephone-fill"></i> {{patron.phone}}
        </div>
    </div>
  </div>
</div>
